import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeStep: 1,
  firstUrl: "",
  previousStep: 0,
};

const stepSlice = createSlice({
  name: "step",
  initialState,
  reducers: {
    increaseStep: (state) => {
      state.activeStep = state.activeStep + 1;
    },
    increaseByNumber: (state, action) => {
      state.activeStep = action.payload;
    },
    saveUrl: (state, action) => {
      state.firstUrl = action.payload;
    },
  },
});

export default stepSlice.reducer;
export const { increaseStep, increaseByNumber, saveUrl } = stepSlice.actions;
